module.exports = __webpack_public_path__ + "fonts/Inter-400-latin-ext48.1ad231a.woff2";